import { render, staticRenderFns } from "./DataToView.vue?vue&type=template&id=52ed6bb7&"
import script from "./DataToView.vue?vue&type=script&lang=js&"
export * from "./DataToView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports